import { render, staticRenderFns } from "./ModuleLegend.vue?vue&type=template&id=c3a16ac2"
import script from "./ModuleLegend.vue?vue&type=script&lang=js"
export * from "./ModuleLegend.vue?vue&type=script&lang=js"
import style0 from "./ModuleLegend.vue?vue&type=style&index=0&id=c3a16ac2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports